let currentIndex = 0;

function updateSlider(containerElement) {
    const sliderItems = containerElement.querySelector('.slider-items');
    const slideCount = sliderItems.children.length;
    const containerWidth = containerElement.querySelector('.slider').offsetWidth;
    
    var totalVisibleItems = 3;
    if (window.matchMedia("(max-width: 800px)").matches) {
      // Change the variable for mobile screens
      totalVisibleItems = 1;
    } 
    const slideWidth = containerWidth / totalVisibleItems;
    
    sliderItems.style.width = `${slideCount * slideWidth / (slideCount / totalVisibleItems)}px`;
    Array.from(sliderItems.children).forEach(child => {
        child.style.width = `${slideWidth}px`;
        child.style.flex = `0 0 calc(100% / ${totalVisibleItems})`
    });
    
    const maxIndex = Math.ceil(slideCount / totalVisibleItems) - 1;
    const prev_arrow = containerElement.querySelector('.prev');
    const next_arrow = containerElement.querySelector('.next');
    prev_arrow.style.visibility = 'visible';
    next_arrow.style.visibility = 'visible';
    if (currentIndex <= 0) {
        currentIndex = 0;
        prev_arrow.style.visibility = 'hidden';
    } else if (currentIndex >= maxIndex) {
        currentIndex = maxIndex;
        next_arrow.style.visibility = 'hidden';
    }

    const offset = -currentIndex * containerWidth;
    sliderItems.style.transform = `translateX(${offset}px)`;
}

function prevSlide(containerElement) {
    currentIndex--;
    updateSlider(containerElement);
}

function nextSlide(containerElement) {
    currentIndex++;
    updateSlider(containerElement);
}

window.onload = () => updateSlider(document.querySelector('.jerseys'));
window.onresize = () => updateSlider(document.querySelector('.jerseys'));